import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ApiHttpService } from 'src/app/services/api-http.service';
import { compilaCf } from 'src/app/shared/validators/validators';
import { setRequired } from '../../shared/utils';
import { filter, pairwise, tap } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { combineLatest, Subscription } from 'rxjs';
import { LoadingOverlayService } from 'src/app/shared/loading.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-dati-anagrafici',
  templateUrl: './dati-anagrafici.component.html',
  styleUrls: ['./dati-anagrafici.component.scss']
})
export class DatiAnagraficiComponent implements OnInit {

  setRequired = setRequired;

  datiAnaForm!: FormGroup;
  get cervedForm(): FormGroup {
    return this.datiAnaForm.get('cervedForm') as FormGroup;
  }
  get cerved_approved() {
    return this.dataService.cerved_approved;
  }

  // showCervedForm = false;

  @ViewChild('scrollable') private scrollable!: ElementRef;
  @ViewChild('dataDiNascita') private dataDiNascita!: ElementRef;

  @ViewChild('cfCli', { static: false }) private cfCli?: ElementRef;
  @ViewChild('cfAmm', { static: false }) private cfAmm?: ElementRef;
  @ViewChild('cfRapp', { static: false }) private cfRapp?: ElementRef;

  formeGiuridiche = [
    { code: 'SOC', value: 'Società' },
    { code: 'DIND', value: 'Ditta individuale / Libero professionista' },
    { code: 'EREL', value: 'Ente morale religioso e Associazioni' },
    { code: 'AMMP', value: 'Amministrazione pubblica' }
  ]

  comuni$: any;
  clienti$: any;
  comuniValue: any;
  datiAnagrafici?: any[];
  cfAziendaCondominio!: number;
  rappLegaleCf: any;
  valueChanges$: { [key: string]: Subscription | undefined } = {};

  get isCfStraniero(): boolean {
    if (this.dataService.prodotto?.tipo_utenza == 'DOM') {
      return this.datiAnaForm.get('cliente')?.get('cfStraniero')?.value == '1';
    } else {
      if (this.datiAnaForm.value.tipoCliente == '0') {
        return this.rappLegale.get('cfStraniero')?.value == '1';
      } else {
        return this.amministratore.get('cfStraniero')?.value == '1';
      }
    }
  }

  constructor(
    private fb: FormBuilder,
    private httpService: ApiHttpService,
    public dataService: DataService
  ) {
    if (this.dataService.prodotto) {
      if (this.dataService.prodotto.tipo_utenza == 'DOM') {
        this.datiAnaForm = this.fb.group({
          cliente: new FormGroup({
            nome: new FormControl(''),
            cognome: new FormControl(''),
            comuneDiNascita: new FormControl(''),
            dataDiNascita: new FormControl(''),
            sesso: new FormControl(''),
            cfStraniero: new FormControl('0'),
            codiceFiscale: new FormControl(''),
            // pec: new FormControl('', [Validators.email]),
            tipoDocIdentica: new FormControl(''),
            nDocIdentica: new FormControl(''),
            // residente: new FormControl('0'),
            cellulare: new FormGroup({
              prefisso: new FormControl('0039'),
              numero: new FormControl(''),
            }),
            telefono: new FormControl(''),
          }),

          indirizzo: new FormGroup({
            toponimo: new FormControl('', [Validators.required]),
            indirizzo: new FormControl('', [Validators.required]),
            civico: new FormControl('', [Validators.required]),
            comune: new FormControl('', [Validators.required]),
            cap: new FormControl('', [Validators.required]),
            provincia: new FormControl('', [Validators.required]),
            indirizzoEstero: new FormControl<boolean>(false),
            nazione: new FormControl(''),
          }),

          consensoDati: new FormControl(false),
          // marketing: new FormControl(false),
          // profilazione: new FormControl(false),
          // comunicazioneTerzi: new FormControl(false),
        });
      } else if (this.dataService.prodotto.tipo_utenza == 'BUS') {
        this.datiAnaForm = this.fb.group({
          tipoCliente: new FormControl('1', [Validators.required]),

          numeroDipendenti: new FormControl(),
          fatturato: new FormControl(),
          tipoPuntiPrelievo: new FormControl(),

          amministratore: new FormGroup({
            nome: new FormControl(''),
            cognome: new FormControl(''),
            comuneDiNascita: new FormControl(''),
            dataDiNascita: new FormControl(''),
            sesso: new FormControl(''),
            cfStraniero: new FormControl('0'),
            codiceFiscale: new FormControl(''),
            tipoDocIdentica: new FormControl(''),
            nDocIdentica: new FormControl(''),
            cellulare: new FormGroup({
              prefisso: new FormControl('0039'),
              numero: new FormControl(''),
            }),
            telefono: new FormControl(''),
          }),
          rappLegale: new FormGroup({
            nome: new FormControl(''),
            cognome: new FormControl(''),
            sesso: new FormControl(''),
            dataDiNascita: new FormControl(''),
            comuneDiNascita: new FormControl(''),
            cfStraniero: new FormControl('0'),
            codiceFiscale: new FormControl(''),
            cellulare: new FormGroup({
              prefisso: new FormControl('0039'),
              numero: new FormControl(''),
            }),
            telefono: new FormControl(''),
          }),
          aziendaCondominio: new FormGroup({
            codiceFiscale: new FormControl('', [Validators.required]),
            ragioneSociale: new FormControl('', [Validators.required]), // Validators.maxLength(15)]
            piva: new FormControl('', [Validators.required, Validators.minLength(11)]),
            formaGiuridica: new FormControl('', [Validators.required])
          }),
          indirizzo: new FormGroup({
            toponimo: new FormControl('', [Validators.required]),
            indirizzo: new FormControl('', [Validators.required]),
            civico: new FormControl('', [Validators.required]),
            comune: new FormControl('', [Validators.required]),
            cap: new FormControl('', [Validators.required]),
            provincia: new FormControl('', [Validators.required]),
            indirizzoEstero: new FormControl<boolean>(false),
            nazione: new FormControl(''),
          }),

          consensoDati: new FormControl(false),
          // marketing: new FormControl(false),
          // profilazione: new FormControl(false),
          // comunicazioneTerzi: new FormControl(false),
        });
        this._bindFormAmm();
      }
      this.setCliente();

    }
  }

  ngOnInit() {

    // this.datiAnaForm.valueChanges.subscribe(_ => {
    //   debugForm(this.datiAnaForm.controls);
    // })

    // this.comuni$ = await this.httpService.get('getComuni').toPromise();
    this.comuni$ = this.httpService.get('getComuni').pipe(tap(data => {
      this.comuniValue = data;
      // if (this.dataService.prodotto?.tipo_utenza == 'DOM') {
      //   this.cliente.setValidators(BWValidators.codiceFiscale(data));
      // } else {
      //   this.amministratore.setValidators(BWValidators.codiceFiscale(data));
      //   this.rappLegale.setValidators(BWValidators.codiceFiscale(data));
      // }
    }));

    this.clienti$ = this.httpService.get('getClienti', { 'auth': this.dataService.auth }).pipe(tap(data => { }));

    combineLatest([
      this.datiAnaForm.get('tipoCliente')?.valueChanges ?? [],
      this.datiAnaForm.get('aziendaCondominio')?.get('formaGiuridica')?.valueChanges ?? [],
      this.datiAnaForm.get('aziendaCondominio')?.get('piva')?.valueChanges ?? [],
      this.datiAnaForm.get('aziendaCondominio')?.get('codiceFiscale')?.valueChanges ?? []
    ]).subscribe(([tipoCliente, formaGiuridica, piva, codiceFiscale]) => {
      if (
        this.dataService.prodotto?.tipo_utenza == 'BUS' &&
        tipoCliente == '0' &&
        this.dataService.user == 3 &&
        formaGiuridica == 'SOC' &&
        piva &&
        codiceFiscale &&
        !(piva.startsWith('8') || piva.startsWith('9')) &&
        !(codiceFiscale.startsWith('8') || codiceFiscale.startsWith('9'))
      ) {
        this.datiAnaForm.addControl('cervedForm', new FormGroup({
          //   power: new FormControl('', Validators.required),
          //   gas: new FormControl('', Validators.required)
        }, cervedValidator(this.dataService)));
        // this.showCervedForm = true;
      } else {
        this.datiAnaForm.removeControl('cervedForm');
        // this.showCervedForm = false;
      }
    });

    setTimeout(() => {
      if (this.dataService.ctr_data) {
        this.datiAnaForm.patchValue(this.dataService.ctr_data.datiAnagrafici);
      }
    }, 2000);

  }

  get indirizzoForm() {
    return this.datiAnaForm.get('indirizzo') as FormGroup;
  }

  get cliente() {
    return this.datiAnaForm.get('cliente') as FormGroup;
  }

  get amministratore() {
    return this.datiAnaForm.get('amministratore') as FormGroup;
  }

  get rappLegale() {
    return this.datiAnaForm.get('rappLegale') as FormGroup;
  }

  get aziendaCondominio() {
    return this.datiAnaForm.get('aziendaCondominio') as FormGroup;
  }

  setCliente() {

    this.dataService.isCfStraniero$.next(this.isCfStraniero);

    if (this.datiAnaForm.value.tipoCliente == '1') {
      // condominio

      this.valueChanges$.amministratore = this.amministratore.valueChanges.pipe(pairwise()).subscribe(([prev, current]) => {
        const nome = { value: this.amministratore.get('nome')?.value, edited: !(prev['nome'] === current['nome']) };
        const cognome = { value: this.amministratore.get('cognome')?.value, edited: !(prev['cognome'] === current['cognome']) };
        const data_di_nascita = { value: this.amministratore.get('dataDiNascita')?.value, edited: !(prev['dataDiNascita'] === current['dataDiNascita']) };
        const comune = { value: this.amministratore.get('comuneDiNascita')?.value, edited: !(prev['comuneDiNascita'] === current['comuneDiNascita']) };
        const sesso = { value: this.amministratore.get('sesso')?.value, edited: !(prev['sesso'] === current['sesso']) };
        const cf = { value: this.amministratore.get('codiceFiscale')?.value, edited: !(prev['codiceFiscale'] === current['codiceFiscale']) };
        const cfStraniero = { value: this.amministratore.get('cfStraniero')?.value, edited: !(prev['cfStraniero'] === current['cfStraniero']) };

        let focused = this.cfAmm?.nativeElement == document.activeElement;
        if ((nome.edited || cognome.edited || data_di_nascita.edited || comune.edited || sesso.edited) && cfStraniero.value == '0' && !focused) {
          if (!!nome.value && !!cognome.value && !!data_di_nascita.value && !!comune.value && !!sesso.value) {
            this.amministratore.get('codiceFiscale')?.patchValue(compilaCf(this.amministratore, this.comuniValue), { emitEvent: false });
          }
        }

      })
      this.valueChanges$.ammCfStraniero = this.amministratore.get('cfStraniero')?.valueChanges.subscribe(value => {
        this.amministratore.get('codiceFiscale')?.clearValidators();
        // this.datiAnaForm.get('indirizzo')?.get('nazione')?.clearValidators();
        if (value == '0') {
          this.amministratore.get('sesso')?.enable({ emitEvent: false });
          this.amministratore.get('comuneDiNascita')?.enable({ emitEvent: false });
          this.amministratore.get('dataDiNascita')?.enable({ emitEvent: false });

          // this.amministratore.get('sesso')?.setValidators([Validators.required]);
          // this.amministratore.get('comuneDiNascita')?.setValidators([Validators.required]);
          // this.amministratore.get('dataDiNascita')?.setValidators([Validators.required]);
          this.amministratore.get('codiceFiscale')?.setValidators([Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i)]);
          // this.datiAnaForm.get('indirizzo')?.get('provincia')?.enable();
        } else {
          this.amministratore.get('sesso')?.disable({ emitEvent: false });
          this.amministratore.get('comuneDiNascita')?.disable({ emitEvent: false });
          this.amministratore.get('dataDiNascita')?.disable({ emitEvent: false });

          // this.amministratore.get('sesso')?.clearValidators();
          // this.amministratore.get('comuneDiNascita')?.clearValidators();
          // this.amministratore.get('dataDiNascita')?.clearValidators();
          // this.amministratore.get('codiceFiscale')?.setValidators([Validators.required]);
          this.amministratore.get('codiceFiscale')?.setValidators([Validators.required, Validators.minLength(16), Validators.maxLength(16)]);
          // this.datiAnaForm.get('indirizzo')?.get('nazione')?.setValidators([Validators.required]);
          // this.datiAnaForm.get('indirizzo')?.get('provincia')?.disable();
        }
        this.amministratore.get('sesso')?.updateValueAndValidity({ emitEvent: false });
        this.amministratore.get('comuneDiNascita')?.updateValueAndValidity({ emitEvent: false });
        this.amministratore.get('dataDiNascita')?.updateValueAndValidity({ emitEvent: false });
        this.amministratore.get('codiceFiscale')?.updateValueAndValidity({ emitEvent: false });

        this.dataService.isCfStraniero$.next(value == '1');
      });

      this.valueChanges$.indirizzoEstero = this.datiAnaForm.get(['indirizzo', 'indirizzoEstero'])?.valueChanges
        .pipe(
          filter(value => typeof value === 'boolean')
        )
        .subscribe(value => {
          this.datiAnaForm.get('indirizzo')?.patchValue({
            toponimo: null,
            indirizzo: null,
            civico: null,
            comune: null,
            cap: null,
            provincia: null,
          }, { emitEvent: false });
          this.datiAnaForm.get('indirizzo')?.markAllAsTouched();
          if (value) {
            this.datiAnaForm.get(['indirizzo', 'nazione'])?.setValidators([Validators.required]);
            this.datiAnaForm.get(['indirizzo', 'provincia'])?.disable();
          } else {
            this.datiAnaForm.get(['indirizzo', 'provincia'])?.enable();
            this.datiAnaForm.get(['indirizzo', 'nazione'])?.clearValidators();
          }
          this.dataService.isIndirizzoEstero$.next(value);
        })

      this.valueChanges$.rappLegale?.unsubscribe();
      this.valueChanges$.rappLegaleCf?.unsubscribe();

      for (let control in this.amministratore.controls) {
        switch (control) {
          case 'codiceFiscale':
            if (this.amministratore.get('cfStraniero')?.value == '0') {
              this.amministratore.controls[control].setValidators([
                Validators.required,
                Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i)
              ]);
            } else {
              this.amministratore.controls[control].setValidators([
                Validators.required,
                Validators.minLength(16),
                Validators.maxLength(16)
              ]);
            }
            continue
          case 'cellulare':
            this.amministratore.get(control)!.get('prefisso')!.setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^[0-9]+$/)]);
            this.amministratore.get(control)!.get('numero')!.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(10), Validators.pattern(/^[0-9]+$/)]);
            continue
          case 'telefono':
            this.amministratore.get(control)!.setValidators([Validators.pattern(/^[0-9]+$/)]);
            continue
          case 'sesso':
          case 'comuneDiNascita':
          case 'dataDiNascita':
            continue
          default:
            this.amministratore.get(control)!.setValidators(Validators.required);
        }
        this.amministratore.controls[control].updateValueAndValidity({ emitEvent: false });
      }
      for (let control in this.rappLegale.controls) {
        if (this.rappLegale.controls[control] instanceof FormGroup) {
          for (let subcontrol in (this.rappLegale.get(control) as FormGroup).controls) {
            this.rappLegale.get(control)!.get(subcontrol)!.clearValidators();
            this.rappLegale.get(control)!.get(subcontrol)!.updateValueAndValidity({ emitEvent: false });
          }
        }
        this.rappLegale.controls[control].clearValidators();
        this.rappLegale.controls[control].updateValueAndValidity({ emitEvent: false });
      }

      this.formeGiuridiche.push(
        { code: 'COND', value: 'Condominio' }
      );
      this.aziendaCondominio.get('formaGiuridica')?.patchValue('COND');
      this.aziendaCondominio.get('formaGiuridica')?.disable();

      this.cfAziendaCondominio = 11;

      // this.datiAnaForm.get('numeroDipendenti')?.clearValidators();
      // this.datiAnaForm.get('fatturato')?.clearValidators();
      // this.datiAnaForm.get('tipoPuntiPrelievo')?.clearValidators();
      // this.datiAnaForm.get('numeroDipendenti')?.updateValueAndValidity({ emitEvent: false });;
      // this.datiAnaForm.get('fatturato')?.updateValueAndValidity({ emitEvent: false });
      // this.datiAnaForm.get('tipoPuntiPrelievo')?.updateValueAndValidity({ emitEvent: false });

    } else if (this.datiAnaForm.value.tipoCliente == '0') {
      // business

      this.valueChanges$.rappLegale = this.rappLegale.valueChanges.pipe(pairwise()).subscribe(([prev, current]) => {
        const nome = { value: this.rappLegale.get('nome')?.value, edited: !(prev['nome'] === current['nome']) };
        const cognome = { value: this.rappLegale.get('cognome')?.value, edited: !(prev['cognome'] === current['cognome']) };
        const data_di_nascita = { value: this.rappLegale.get('dataDiNascita')?.value, edited: !(prev['dataDiNascita'] === current['dataDiNascita']) };
        const comune = { value: this.rappLegale.get('comuneDiNascita')?.value, edited: !(prev['comuneDiNascita'] === current['comuneDiNascita']) };
        const sesso = { value: this.rappLegale.get('sesso')?.value, edited: !(prev['sesso'] === current['sesso']) };
        const cf = { value: this.rappLegale.get('codiceFiscale')?.value, edited: !(prev['codiceFiscale'] === current['codiceFiscale']) };
        const cfStraniero = { value: this.rappLegale.get('cfStraniero')?.value, edited: !(prev['cfStraniero'] === current['cfStraniero']) };

        let focused = this.cfRapp?.nativeElement == document.activeElement;
        if ((nome.edited || cognome.edited || data_di_nascita.edited || comune.edited || sesso.edited) && cfStraniero.value == '0' && !focused) {
          if (!!nome.value && !!cognome.value && !!data_di_nascita.value && !!comune.value && !!sesso.value) {
            this.rappLegale.get('codiceFiscale')?.patchValue(compilaCf(this.rappLegale, this.comuniValue), { emitEvent: false });
          }
        }

      })
      this.valueChanges$.rappLegaleCf = this.rappLegale.get('cfStraniero')?.valueChanges.subscribe(value => {
        this.rappLegale.get('codiceFiscale')?.clearValidators();
        if (value == '0') {
          this.rappLegale.get('sesso')?.enable({ emitEvent: false });
          this.rappLegale.get('comuneDiNascita')?.enable({ emitEvent: false });
          this.rappLegale.get('dataDiNascita')?.enable({ emitEvent: false });

          // this.rappLegale.get('sesso')?.setValidators([Validators.required]);
          // this.rappLegale.get('comuneDiNascita')?.setValidators([Validators.required]);
          // this.rappLegale.get('dataDiNascita')?.setValidators([Validators.required]);
          this.rappLegale.get('codiceFiscale')?.addValidators([Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i)]);
        } else {
          this.rappLegale.get('sesso')?.disable({ emitEvent: false });
          this.rappLegale.get('comuneDiNascita')?.disable({ emitEvent: false });
          this.rappLegale.get('dataDiNascita')?.disable({ emitEvent: false });

          // this.rappLegale.get('sesso')?.clearValidators();
          // this.rappLegale.get('comuneDiNascita')?.clearValidators();
          // this.rappLegale.get('dataDiNascita')?.clearValidators();
          // this.rappLegale.get('codiceFiscale')?.setValidators([Validators.required]);
          this.rappLegale.get('codiceFiscale')?.setValidators([Validators.required, Validators.minLength(16), Validators.maxLength(16)]);
        }
        this.rappLegale.get('sesso')?.updateValueAndValidity({ emitEvent: false });
        this.rappLegale.get('comuneDiNascita')?.updateValueAndValidity({ emitEvent: false });
        this.rappLegale.get('dataDiNascita')?.updateValueAndValidity({ emitEvent: false });
        this.rappLegale.get('codiceFiscale')?.updateValueAndValidity({ emitEvent: false });

        this.dataService.isCfStraniero$.next(value == '1');
      })

      this.valueChanges$.amministratore?.unsubscribe();
      this.valueChanges$.ammCfStraniero?.unsubscribe();
      this.valueChanges$.indirizzoEstero?.unsubscribe();

      for (let control in this.amministratore.controls) {
        if (this.amministratore.controls[control] instanceof FormGroup) {
          for (let subcontrol in (this.amministratore.get(control) as FormGroup).controls) {
            this.amministratore.get(control)!.get(subcontrol)!.clearValidators();
            this.amministratore.get(control)!.get(subcontrol)!.updateValueAndValidity({ emitEvent: false });
          }
        }
        this.amministratore.controls[control].clearValidators();
        this.amministratore.controls[control].updateValueAndValidity({ emitEvent: false });
      }
      for (let control in this.rappLegale.controls) {
        switch (control) {
          case 'codiceFiscale':
            if (this.rappLegale.get('cfStraniero')?.value == '0') {
              this.rappLegale.controls[control].setValidators([
                Validators.required,
                Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i)
              ]);
            } else {
              this.rappLegale.controls[control].setValidators([
                Validators.required,
                Validators.minLength(16),
                Validators.maxLength(16)
              ]);
            }
            continue
          case 'cellulare':
            this.rappLegale.get(control)!.get('prefisso')!.setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^[0-9]+$/)]);
            this.rappLegale.get(control)!.get('numero')!.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(10), Validators.pattern(/^[0-9]+$/)]);
            continue
          case 'telefono':
            this.rappLegale.get(control)!.setValidators([Validators.maxLength(11), Validators.pattern(/^[0-9]+$/)]);
            continue
          case 'sesso':
          case 'comuneDiNascita':
          case 'dataDiNascita':
            continue
          default:
            this.rappLegale.get(control)!.setValidators(Validators.required);
        }
        this.rappLegale.controls[control].updateValueAndValidity({ emitEvent: false });
      }

      this.formeGiuridiche.map((el, i) => {
        if (el.code == 'COND') {
          this.formeGiuridiche.splice(i, 1);
        }
      })
      this.aziendaCondominio.get('formaGiuridica')?.patchValue(null);
      this.aziendaCondominio.get('formaGiuridica')?.enable();

      this.aziendaCondominio.get('formaGiuridica')?.valueChanges.subscribe(value => {
        this.aziendaCondominio.get('codiceFiscale')?.clearValidators();
        if (value == 'DIND') {
          this.cfAziendaCondominio = 16;
          this.aziendaCondominio.get('codiceFiscale')?.addValidators([Validators.required, Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i), Validators.maxLength(16)]);
          this.aziendaCondominio.get('piva')?.clearValidators();
        }
        else if (value == 'EREL') {
          this.cfAziendaCondominio = 11;
          this.aziendaCondominio.get('codiceFiscale')?.clearValidators();
          this.aziendaCondominio.get('piva')?.setValidators([Validators.required, Validators.minLength(11)]);
        }
        else {
          this.cfAziendaCondominio = 11;
          this.aziendaCondominio.get('codiceFiscale')?.addValidators([Validators.required, Validators.maxLength(11), Validators.minLength(11)]);
          this.aziendaCondominio.get('piva')?.setValidators([Validators.required, Validators.minLength(11)]);
        }
        this.aziendaCondominio.get('codiceFiscale')?.updateValueAndValidity({ emitEvent: false });
      })

      // if (this.dataService.prodotto?.cod_tipo_fornitura_id != 'GAS') {
      //   this.datiAnaForm.get('numeroDipendenti')?.addValidators(Validators.required);
      //   this.datiAnaForm.get('fatturato')?.addValidators(Validators.required);
      //   this.datiAnaForm.get('tipoPuntiPrelievo')?.addValidators(Validators.required);
      // }

    } else {
      // domestico

      this.valueChanges$.cliente = this.cliente.valueChanges.pipe(pairwise()).subscribe(([prev, current]) => {
        const nome = { value: this.cliente.get('nome')?.value, edited: !(prev['nome'] === current['nome']) };
        const cognome = { value: this.cliente.get('cognome')?.value, edited: !(prev['cognome'] === current['cognome']) };
        const data_di_nascita = { value: this.cliente.get('dataDiNascita')?.value, edited: !(prev['dataDiNascita'] === current['dataDiNascita']) };
        const comune = { value: this.cliente.get('comuneDiNascita')?.value, edited: !(prev['comuneDiNascita'] === current['comuneDiNascita']) };
        const sesso = { value: this.cliente.get('sesso')?.value, edited: !(prev['sesso'] === current['sesso']) };
        const cf = { value: this.cliente.get('codiceFiscale')?.value, edited: !(prev['codiceFiscale'] === current['codiceFiscale']) };
        const cfStraniero = { value: this.cliente.get('cfStraniero')?.value, edited: !(prev['cfStraniero'] === current['cfStraniero']) };

        let focused = this.cfCli?.nativeElement == document.activeElement;
        if ((nome.edited || cognome.edited || data_di_nascita.edited || comune.edited || sesso.edited) && cfStraniero.value == '0' && !focused) {
          if (!!nome.value && !!cognome.value && !!data_di_nascita.value && !!comune.value && !!sesso.value) {
            this.cliente.get('codiceFiscale')?.patchValue(compilaCf(this.cliente, this.comuniValue), { emitEvent: false });
          }
        }

      })
      this.valueChanges$.cliCfStraniero = this.cliente.get('cfStraniero')?.valueChanges.subscribe(value => {
        this.cliente.get('codiceFiscale')?.clearValidators();
        // this.datiAnaForm.get('indirizzo')?.get('nazione')?.clearValidators();
        if (value == '0') {
          this.cliente.get('sesso')?.enable({ emitEvent: false });
          this.cliente.get('comuneDiNascita')?.enable({ emitEvent: false });
          this.cliente.get('dataDiNascita')?.enable({ emitEvent: false });

          // this.cliente.get('sesso')?.setValidators([Validators.required]);
          // this.cliente.get('comuneDiNascita')?.setValidators([Validators.required]);
          // this.cliente.get('dataDiNascita')?.setValidators([Validators.required]);
          this.cliente.get('codiceFiscale')?.setValidators([Validators.required, Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i)]);
          // this.datiAnaForm.get('indirizzo')?.get('provincia')?.enable();
        } else {
          this.cliente.get('sesso')?.disable({ emitEvent: false });
          this.cliente.get('comuneDiNascita')?.disable({ emitEvent: false });
          this.cliente.get('dataDiNascita')?.disable({ emitEvent: false });

          // this.cliente.get('sesso')?.clearValidators();
          // this.cliente.get('comuneDiNascita')?.clearValidators();
          // this.cliente.get('dataDiNascita')?.clearValidators();
          this.cliente.get('codiceFiscale')?.setValidators([Validators.required, Validators.minLength(16), Validators.maxLength(16)]);
          // this.cliente.get('codiceFiscale')?.setValidators([Validators.required, Validators.minLength(16), Validators.maxLength(16)]);
          // this.datiAnaForm.get('indirizzo')?.get('nazione')?.setValidators([Validators.required]);
          // this.datiAnaForm.get('indirizzo')?.get('provincia')?.disable();
        }
        this.cliente.get('sesso')?.updateValueAndValidity({ emitEvent: false });
        this.cliente.get('comuneDiNascita')?.updateValueAndValidity({ emitEvent: false });
        this.cliente.get('dataDiNascita')?.updateValueAndValidity({ emitEvent: false });
        this.cliente.get('codiceFiscale')?.updateValueAndValidity({ emitEvent: false });

        this.dataService.isCfStraniero$.next(value == '1');
      })

      this.datiAnaForm.get(['indirizzo', 'indirizzoEstero'])?.valueChanges
        .pipe(
          filter(value => typeof value === 'boolean')
        )
        .subscribe(value => {
          this.datiAnaForm.get('indirizzo')?.patchValue({
            toponimo: null,
            indirizzo: null,
            civico: null,
            comune: null,
            cap: null,
            provincia: null,
          }, { emitEvent: false });
          this.datiAnaForm.get('indirizzo')?.markAllAsTouched();
          if (value) {
            this.datiAnaForm.get(['indirizzo', 'nazione'])?.setValidators([Validators.required]);
            this.datiAnaForm.get(['indirizzo', 'provincia'])?.disable();
          } else {
            this.datiAnaForm.get(['indirizzo', 'provincia'])?.enable();
            this.datiAnaForm.get(['indirizzo', 'nazione'])?.clearValidators();
          }
          this.dataService.isIndirizzoEstero$.next(value);
        })

      for (let control in this.cliente.controls) {
        switch (control) {
          case 'codiceFiscale':
            this.cliente.controls[control].setValidators([
              Validators.required,
              Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i)
            ]);
            continue
          // case 'pec':
          //   continue
          case 'cellulare':
            this.cliente.get(control)!.get('prefisso')!.setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^[0-9]+$/)]);
            this.cliente.get(control)!.get('numero')!.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(10), Validators.pattern(/^[0-9]+$/)]);
            continue
          case 'telefono':
            this.cliente.get(control)!.setValidators([Validators.maxLength(11), Validators.pattern(/^[0-9]+$/)]);
            continue
          case 'sesso':
          case 'comuneDiNascita':
          case 'dataDiNascita':
            continue
          default:
            this.cliente.get(control)!.setValidators(Validators.required);
        }
      }

    }
  }

  clienteSelected(evento: any) {
    // funzione usata per catturare l'evento dalla selezione dell'autocomplete del cliente esistente
    // this.httpService.get('getInfoCliente', {id_cliente: evento.id_cliente}).subscribe(data => {
    // this.datiAnaForm.setValue(1);
    // })
  }

  goBottom() {
    this.scrollable.nativeElement.scrollTop = this.scrollable.nativeElement.scrollHeight;
  }

  // validateCf(form: FormGroup) {

  //   this.cfAmmChecking = true;
  //   let data = {
  //     nome: form.controls.nome.value,
  //     cognome: form.controls.cognome.value,
  //     comuneDiNascita: form.controls.comuneDiNascita.value,
  //     dataDiNascita: form.controls.dataDiNascita.value.format('DD/MM/YYYY'),
  //     sesso: form.controls.sesso.value
  //   }

  //   this.httpService.post('generateCf', data).subscribe(res => {
  //     console.log(res);
  //     // form.get('codiceFiscale')?.patchValue(res.cf)
  //     this.cfAmmChecking = false;
  //     if (res.cf != form.get('codiceFiscale')?.value.toUpperCase()) {
  //       form.get('codiceFiscale')!.setErrors({ 'invalid': true })
  //       this.cfAmmChecked = false;
  //     } else {
  //       this.cfAmmChecked = true;
  //     }

  //   }, error => {
  //     console.log(error);
  //     this.cfAmmChecking = false;
  //   })

  // }

  secondLineFnCliente(item: any) {
    return `${item.partita_iva ? item.partita_iva : item.codice_fiscale}`;
  }
  get_cod_belfiore() {
    // console.log(this.datiAnaForm);
    const value = this.amministratore.getRawValue();
    if (value.comuneDiNascita) {
      return this.comuniValue.find((x: any) => x.id_comune === value.comuneDiNascita)?.cod_belfiore;
    } else {
      return undefined;
    }
  }

  private _bindFormAmm() {
    this.amministratore.get('nome')?.valueChanges.subscribe(value => {
      let nome = value;
      let cognome = this.amministratore.get('cognome')?.value;
      let ragione_sociale = this.amministratore.get('ragioneSociale')?.value;

      if (nome || cognome) {
        this.amministratore.get('ragioneSociale')?.disable({ emitEvent: false });
        this.amministratore.get('ragioneSociale')?.removeValidators(Validators.required);
      } else {
        this.amministratore.get('ragioneSociale')?.enable({ emitEvent: false });
        this.amministratore.get('ragioneSociale')?.addValidators(Validators.required);
      }
    });
    this.amministratore.get('cognome')?.valueChanges.subscribe(value => {
      let nome = this.amministratore.get('nome')?.value;
      let cognome = value;
      let ragione_sociale = this.amministratore.get('ragioneSociale')?.value;

      if (nome || cognome) {
        this.amministratore.get('ragioneSociale')?.disable({ emitEvent: false });
        this.amministratore.get('ragioneSociale')?.removeValidators(Validators.required);
      } else {
        this.amministratore.get('ragioneSociale')?.enable({ emitEvent: false });
        this.amministratore.get('ragioneSociale')?.addValidators(Validators.required);
      }
    });
    this.amministratore.get('ragioneSociale')?.valueChanges.subscribe(value => {
      let nome = this.amministratore.get('nome')?.value;
      let cognome = this.amministratore.get('cognome')?.value;

      if (value) {
        this.amministratore.get('nome')?.disable({ emitEvent: false });
        this.amministratore.get('cognome')?.disable({ emitEvent: false });
        this.amministratore.get('nome')?.removeValidators(Validators.required);
        this.amministratore.get('cognome')?.removeValidators(Validators.required);
      } else {
        this.amministratore.get('nome')?.enable({ emitEvent: false });
        this.amministratore.get('cognome')?.enable({ emitEvent: false });

        this.amministratore.get('nome')?.addValidators(Validators.required);
        this.amministratore.get('cognome')?.addValidators(Validators.required);
      }
    });
  }


}


export function cervedValidator(dataService: DataService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (dataService.results_cerved) {
      if (dataService.results_cerved.cerved_score === 'ROSSO') {
        return { cervedScore: 'ROSSO' };
      }
      return null;
    } else {
      return dataService.cerved_approved ? null : { cervedApproved: dataService.cerved_approved };
    }
  }
}

@Component({
  selector: 'cerved',
  template: `
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
    <!-- <form [formGroup]="cervedForm" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field>
          <mat-label>Energia (kWh)</mat-label>
          <input class="volume" type='text' matInput formControlName="power" [required]="setRequired(cervedForm.get('power'))">
          <mat-error *ngIf="cervedForm.get('power')!.hasError('required')">
            Campo obbligatorio
          </mat-error>
          <mat-error *ngIf="cervedForm.get('power')!.hasError('pattern')">
            Inserire valori numerici
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Gas (Smc)</mat-label>
          <input class="volume" type='text' matInput formControlName="gas" [required]="setRequired(cervedForm.get('gas'))">
          <mat-error *ngIf="cervedForm.get('gas')!.hasError('required')">
            Campo obbligatorio
          </mat-error>
          <mat-error *ngIf="cervedForm.get('gas')!.hasError('pattern')">
            Inserire valori numerici
          </mat-error>
        </mat-form-field>
      </form> -->
    <div fxFLex>
      <!-- <button fxFill mat-icon-button [disabled]="cervedForm.get('power')?.invalid || cervedForm.get('gas')?.invalid || datiAnagrafici.datiAnaForm.get('aziendaCondominio')?.invalid" (click)="interroga()"> -->
      <button
        fxFill
        mat-icon-button
        [disabled]="datiAnagrafici.datiAnaForm.get('aziendaCondominio')?.invalid"
        (click)="interroga()"
      >
        <mat-icon color="primary" style="margin-right: 5px">query_stats</mat-icon>
        Interroga
      </button>
    </div>

  </div>
  
  <p *ngIf="piva_not_found" style="color: red">
    Attenzione, partita Iva non trovata nel sistema Cerved
  </p>

  <ng-container *ngIf="results_cerved && !results_cerved?.piva_not_found">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="40px">
      <!-- <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
          <p>Score: {{results_cerved.cerved_score | number: '1.0-0'}}</p>
          <p>Patrimonio netto: {{(results_cerved.patrimonio_netto !== null ? (results_cerved.patrimonio_netto * 1000 | currency: 'symbol' : '€' : '1.0-0') : '---') || '---'}}</p>
          <p>Imm. immateriali: {{(results_cerved.immobili_immateriali !== null ? (results_cerved.immobili_immateriali * 1000 | currency: 'symbol' : '€' : '1.0-0') : '---') || '---'}}</p>

          <ng-container *ngIf="results_cerved.presenza_eventi_negativi; else noEventiNegativi">
            <div fxLayout="row" fxLayoutAlign="start center">
              <label>Presenza eventi negativi:</label>
              <button mat-button (click)="openEventiNegativi()" fxLayoutAlign="center start">SI</button>
            </div>
          </ng-container>
          <ng-template #noEventiNegativi>
            <p>Presenza eventi negativi: NO</p>
          </ng-template>

        </div> -->
      <div class="cerved_results" fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <!-- <mat-icon *ngIf="cerved_approved" color="green" matTooltip="Approvato">thumb_up</mat-icon>
        <mat-icon *ngIf="cerved_approved == false" color="warn" matTooltip="Respinto" >front_hand</mat-icon> -->
        <div>
          <mat-icon *ngIf="results_cerved.cerved_score == 'VERDE'" color="green" matTooltip="Approvato">thumb_up</mat-icon>
          <mat-icon *ngIf="results_cerved.cerved_score == 'ARANCIONE'" color="orange" matTooltip="Approvato con riserva">front_hand</mat-icon>
          <mat-icon *ngIf="results_cerved.cerved_score == 'ROSSO'" color="warn" matTooltip="Non approvato">front_hand</mat-icon>
        </div>
        <div>
          <label *ngIf="results_cerved.cerved_score == 'VERDE'">Cliente approvato</label>
          <label *ngIf="results_cerved.cerved_score == 'ARANCIONE'">
            Cliente approvato con riserva
          </label>
          <label *ngIf="results_cerved.cerved_score == 'ROSSO'">
            Cliente non approvato, si prega di contattare il proprio referente commerciale
          </label>
        </div>
      </div>
      <!-- <div fxLayout="column" fxLayoutGap="10px">
          <p>Prezzo: {{results_cerved.prezzo | currency: 'EUR':unita_misura:'1.0-9':'it'}}</p>
          <p>Percentuale: {{results_cerved.percentuale | number: '1.0-5'}} %</p>
          <p>Esposizione: {{(volume * results_cerved.prezzo * 1.3)/3 | currency:'EUR':'symbol':'1.0-0':'it'}}</p>
          <p>Assicurazione: {{results_cerved.patrimonio_netto !== null && results_cerved.immobili_immateriali !== null ? (
                              (results_cerved.percentuale * (
                                (results_cerved.patrimonio_netto * 1000 - results_cerved.immobili_immateriali * 1000) < 0 ?
                                  0 : results_cerved.patrimonio_netto * 1000 - results_cerved.immobili_immateriali * 1000
                                )
                              ) | currency:'EUR':'symbol':'1.0-0':'it'
                            ) : '---'}}
          </p>
          <p>Delta: {{results_cerved.patrimonio_netto !== null && results_cerved.immobili_immateriali !== null ? (
                      ((
                        (volume * results_cerved.prezzo * 1.3)/3) - (results_cerved.percentuale * (
                          (results_cerved.patrimonio_netto * 1000 - results_cerved.immobili_immateriali * 1000) < 0 ?
                          0 : results_cerved.patrimonio_netto * 1000 - results_cerved.immobili_immateriali * 1000
                        )
                      ) < 0 ? 0 : (
                        (volume * results_cerved.prezzo * 1.3)/3) - (results_cerved.percentuale * (
                          (results_cerved.patrimonio_netto * 1000 - results_cerved.immobili_immateriali * 1000) < 0 ?
                          0 : results_cerved.patrimonio_netto * 1000 - results_cerved.immobili_immateriali * 1000
                        )
                      )) | currency:'EUR':'symbol':'1.0-0':'it'
                    ) : '---'}}
          </p>
        </div> -->
    </div>
  </ng-container>

  `,
  styleUrls: ['./dati-anagrafici.component.scss']
})

export class CervedComponent implements OnInit {

  setRequired = setRequired;

  get cerved_approved() {
    return this.dataService.cerved_approved;
  }
  set cerved_approved(value) {
    this.dataService.cerved_approved = value;
  }

  get volume() {
    if (this.cervedForm.get('power')?.value) {
      return this.cervedForm.get('power')?.value?.replace('.', '')?.replace(',', '.');
    } else {
      return this.cervedForm.get('gas')?.value?.replace('.', '')?.replace(',', '.');
    }
  }

  get results_cerved() {
    return this.dataService.results_cerved;
  }
  set results_cerved(value) {
    this.dataService.results_cerved = value;
  }

  get unita_misura() {
    return this.cervedForm.get('power')?.value ? '€/kWh' : '€/Smc';
  }


  @Input() cervedForm!: FormGroup;
  constructor(
    private httpService: ApiHttpService,
    private loading: LoadingOverlayService,
    private dataService: DataService,
    public datiAnagrafici: DatiAnagraficiComponent,
    private dialog: MatDialog
  ) { }

  piva_not_found = false;

  ngOnInit() {

    // this.datiAnagrafici.datiAnaForm.get('aziendaCondominio')?.valueChanges.subscribe(_ => {
    //   if (this.datiAnagrafici.datiAnaForm.get('aziendaCondominio')?.invalid) {
    //     this.cerved_approved = false;
    //     this.piva_not_found = false;
    //     this.results_cerved = null;
    //     this.cervedForm.reset();
    //     this.cervedForm.updateValueAndValidity();
    //   }
    // });

    // this.cervedForm.valueChanges.subscribe(value => {
    //   // this.cervedForm.clearValidators();
    //   if (value.power) {
    //     this.cervedForm.get('gas')?.disable({ emitEvent: false });
    //     this.cervedForm.get('gas')?.clearValidators();

    //     let numbers = this.cervedForm.get('power')?.value.split(',')
    //     if (numbers && numbers[0].length > 0) {
    //       let numero = numbers[0].replace(/\./g, '');
    //       numero = parseInt(numero).toLocaleString('it-IT');
    //       // if (numbers[1] != undefined) {
    //       //   numero += ','
    //       //   if (numbers[1].length > 0) {
    //       //     numero += parseInt(numbers[1]).toLocaleString('it-IT');

    //       //   }
    //       // }
    //       this.cervedForm.get('power')?.setValue(numero, { emitEvent: false });
    //     }
    //   } else {
    //     this.cervedForm.get('gas')?.enable({ emitEvent: false });
    //     this.cervedForm.get('gas')?.setValidators([Validators.required, Validators.pattern(/^\d{1,3}(?:\.\d{3})*(?:,\d+)?$/)]);
    //   }

    //   if (value.gas) {
    //     this.cervedForm.get('power')?.disable({ emitEvent: false });
    //     this.cervedForm.get('power')?.clearValidators();

    //     let numbers = this.cervedForm.get('gas')?.value.split(',')
    //     if (numbers && numbers[0].length > 0) {
    //       let numero = numbers[0].replace(/\./g, '');
    //       numero = parseInt(numero).toLocaleString('it-IT');
    //       // if (numbers[1] != undefined) {
    //       //   numero += ','
    //       //   if (numbers[1].length > 0) {
    //       //     numero += parseInt(numbers[1]).toLocaleString('it-IT');

    //       //   }
    //       // }
    //       this.cervedForm.get('gas')?.setValue(numero, { emitEvent: false });
    //     }
    //   } else {
    //     this.cervedForm.get('power')?.enable({ emitEvent: false });
    //     this.cervedForm.get('power')?.setValidators([Validators.required, Validators.pattern(/^\d{1,3}(?:\.\d{3})*(?:,\d+)?$/)]);
    //   }

    //   if (!value.power && !value.gas) {
    //     this.dataService.results_cerved = null;
    //   }

    //   let volume = this.volume;
    //   if (this.volume) {
    //     volume = parseInt(this.volume.split(',')[0].replace(/\./g, ''));
    //   }
    //   this.dataService.volume_cerved = volume;

    // })

  }

  interroga() {
    // let data = this.cervedForm.value;
    // if (data.power && data.power.length > 0) {
    //   let numbers = data.power.split(',');
    //   let numero = numbers[0].replace(/\./g, '');
    //   data.power = parseFloat([numero, numbers[1]].join('.'))
    // }
    // if (data.gas && data.gas.length > 0) {
    //   let numbers = data.gas.split(',');
    //   let numero = numbers[0].replace(/\./g, '');
    //   data.gas = parseFloat([numero, numbers[1]].join('.'))
    // }
    this.loading.show();
    this.piva_not_found = false;
    let piva = this.datiAnagrafici.datiAnaForm.get('aziendaCondominio')?.get('piva')?.value;
    if (!piva) {
      piva = this.datiAnagrafici.datiAnaForm.get('aziendaCondominio')?.get('codiceFiscale')?.value;
    }
    this.httpService.post('cerved', {
      // ...data,
      vendor: this.dataService.vendor,
      piva: piva
    }).subscribe((res: any) => {
      this.results_cerved = res;

      // if (res.presenza_eventi_negativi) {
      //   this.cerved_approved = false;
      // } else {
      //   if (res.aspme_score) {
      //     this.cerved_approved = res.aspme_score <= 0;
      //   } else {
      //     if (res.cerved_score >= 73) {
      //       this.cerved_approved = true;
      //     } else {
      //       this.cerved_approved = false;
      //     }
      //   }
      // }
      this.cervedForm.updateValueAndValidity();
    }, (err) => {
      this.cerved_approved = false;
      this.piva_not_found = true;
      this.results_cerved = {
        piva_not_found: true
      };
      this.loading.hide();
      this.cervedForm.updateValueAndValidity();
    }, () => {
      this.loading.hide();
    })
  }

  openEventiNegativi() {
    this.dialog.open(EventiNegativiComponent, {
      data: this.results_cerved.lista_eventi_negativi
    });
  }

}


@Component({
  template: `
    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
      <div fxFill fxLayout="row" fxLayoutAlign="end start">
        <button mat-icon-button (click)="dialogRef.close()" fxLayoutAlign="center center">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <pre>{{data | json}}</pre>
    </div>
  `
})

export class EventiNegativiComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<EventiNegativiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() { }
}